import { render, staticRenderFns } from "./OrderCenter.vue?vue&type=template&id=3ce9d026&"
import script from "./OrderCenter.vue?vue&type=script&lang=js&"
export * from "./OrderCenter.vue?vue&type=script&lang=js&"
import style0 from "./OrderCenter.vue?vue&type=style&index=0&id=3ce9d026&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports